import type { IPRule, TimeRule } from '@/features/sharing-profile/types/sharing-profile.interface';

export interface SharingPoliciesState {
  /** Time-of-day rules keyed by day (e.g. "Mon", "Tue"). */
  timeRules: Record<string, TimeRule>;
  /** IP allow/deny rules keyed by a generated rule ID. */
  ipRules: Record<string, IPRule>;
  /** Whether time-of-day/timezone restrictions are enabled for the profile. */
  timezone: boolean;
  /** Whether IP restrictions are enabled for the profile. */
  ipRestrictions: boolean;
}

export const initialPoliciesState: SharingPoliciesState = {
  timeRules: {},
  ipRules: {},
  timezone: false,
  ipRestrictions: false,
};
